import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { PaymentConceptService } from '../../../../../../services/payment-concept/payment-concept.service';
import { Observable } from 'rxjs/Observable';
import { PaymentConcept } from '../../../../../../models/payment-concept/payment-concept';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';

@Component({
    selector: 'fuse-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./peyment.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class PaymentComponent implements OnInit, AfterViewInit, OnDestroy {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;

    receiptNumberFormControl;
    amountFormControl;
    dateFormControl;
    paymentConceptFormControl;
    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    public attrs = [];
    public typeEmployees = [];
    public jobTitles = [];
    public shifts = [];
    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerDate;
    @ViewChild('date', {read: ViewContainerRef}) public date;
    public paymentsConcepts: PaymentConcept[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PaymentComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        public paymentConceptService: PaymentConceptService
    ) {
        console.log('FuseAddStudentComponent > data', data);
        this.initializeFormControlValidators();
        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.formGroup.get('amountFormControl').disable();
        this.formGroup.get('receiptNumberFormControl').disable();
        this.formGroup.get('dateFormControl').disable();
        this.formGroup.get('paymentConceptFormControl').disable();
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            amountFormControl: ['', [Validators.required]],
            receiptNumberFormControl: [''],
            dateFormControl: ['', [Validators.required]],
            paymentConceptFormControl: ['', [Validators.required]],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerDate = textMask.maskInput({
                inputElement: this.date.element.nativeElement,
                mask: this.mask
            });


        });
    }

    ngOnDestroy() {
        this.maskedInputControllerDate.destroy();
    }


    ngOnInit() {        
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.paymentConceptService.getAll()
        ).subscribe(([paymentsConcepts]) => {
            this.paymentsConcepts = paymentsConcepts;
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    save() {
        this.dialogRef.close(this.data.payment);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/payment/payment.component.ts